import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/other/payments', config);
}

const get = async (code) => {
    return FinanceApi.get('/other/payments/' + code);
}

const store = async (data) => {
    if (data.id) {
        return FinanceApi.put('/other/payments/' + data.id, data);
    }
    return FinanceApi.post('/other/payments', data);
}

const update = async (id, formData) => {
    return FinanceApi.put('/other/payments/' + id, formData);
}

const del = async (id) => {
    return FinanceApi.delete('/other/payments/' + id);
}

export default {
    getAll,
    get,
    store,
    update,
    del
}
